import React from 'react';
import { REPORT_SECTIONS } from './reportSections';

const ReportsSidebar = ({ selectedId, onSelect }) => (
  <div
    style={{
      width: '280px',
      flexShrink: 0,
      borderRight: '1px solid #e5e5e5',
      overflowY: 'auto',
    }}
  >
    {REPORT_SECTIONS.map((section, idx) => (
      <div
        key={section.title}
        style={{
          padding: idx === 0 ? '12px 0 16px' : '16px 0',
          borderBottom: idx === REPORT_SECTIONS.length - 1 ? 'none' : '1px solid #e5e5e5',
        }}
      >
        <div
          style={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#222',
            padding: '0 24px',
            marginBottom: '8px',
          }}
        >
          {section.title}
        </div>
        {section.items.map((item) => {
          const isSelected = item.id === selectedId;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item.id)}
              aria-current={isSelected ? 'page' : undefined}
              style={{
                display: 'block',
                width: '100%',
                border: 'none',
                textAlign: 'left',
                fontFamily: 'inherit',
                padding: '8px 24px',
                cursor: 'pointer',
                fontSize: '15px',
                background: isSelected ? '#e5e5e5' : 'transparent',
                fontWeight: isSelected ? 600 : 400,
                color: '#222',
              }}
            >
              {item.name}
            </button>
          );
        })}
      </div>
    ))}
  </div>
);

export default ReportsSidebar;
